import type {IAttributes, IAugmentedJQuery, IScope} from 'angular';

/**
 * @ngdoc directive
 * @name kpOnError
 * @module portaro.directives
 *
 * @param {expression} kpOnError Expression.
 *
 * @description
 * Expression in attribute is evaluated on element's `onerror` event fired.
 *
 * @example
 * ```html
 * <example name="kpOnErrorExample" module="kpOnErrorExample">
 *     <file name="index.html">
 *         <main ng-init="showError = false" ng-controller="kpOnErrorExampleController as ctrl">
 *             <img ng-src="{{ctrl.src}}" kp-on-error="showError = true">
 *             <div ng-show="showError">Error okurek</div>
 *         </main>
 *     </file>
 *     <file name="script.js">
 *         angular.module('kpOnErrorExample', ['portaro.directives'])
 *              .controller('kpOnErrorExampleController', class {
 *
 *                  constructor($timeout) {
 *                      this.src = 'https://loading.io/spinners/spinner/index.ajax-spinner-preloader.gif';
 *
 *                      $timeout(() => this.src = 'some.erroneous.domain', 2000);
 *                  }
 *              });
 *     </file>
 * </example>
 * ```
 */
export default class KpOnErrorDirective {
    public static directiveName = 'kpOnError';

    public restrict = 'A';

    public link($scope: IScope, $element: IAugmentedJQuery, $attrs: IAttributes) {

        const onErrorHandler = () => {
            if ($attrs[KpOnErrorDirective.directiveName]) {
                $scope.$apply(() => $scope.$eval($attrs[KpOnErrorDirective.directiveName]));
            }
        };

        $element.on('error', onErrorHandler);

        $scope.$on('$destroy', () => {
            $element.off('error', onErrorHandler);
        });
    }
}
